import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export function RenameForm({ teamId, item, onDone }) {
  const [name, setName] = useState(item.name); const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    const url = item.type === "file" ? `/teams/${teamId}/files/${item.id}` : `/teams/${teamId}/folders/${item.id}`;
    try { await api.patch(url, { name }); toast.success("Renamed"); onDone(); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-4">
      <input data-testid="rename-input" autoFocus required value={name} onChange={(e) => setName(e.target.value)} className="w-full px-3 py-2.5 border border-black/15 rounded-md outline-none focus:border-black"/>
      <button data-testid="rename-submit" disabled={busy} className="w-full bg-black text-white py-2.5 rounded-md disabled:opacity-50">{busy ? "Saving…" : "Rename"}</button>
    </form>
  );
}
